import React from 'react'
import classnames from 'classnames'

import { PreMakingTemplate } from '../../../core/pre-making'
import styles from '../../styles/modules/table.module.scss'
import formStyles from '../../styles/modules/each-item/each-item-forms.module.scss'

interface Props {
  template: PreMakingTemplate
  isEditing: boolean
  editTemplateName: string
  editTemplateDescription: string
  onNameChange: (value: string) => void
  onDescriptionChange: (value: string) => void
}

const PreMakingTemplateInfoForm: React.FC<Props> = ({
  template,
  isEditing,
  editTemplateName,
  editTemplateDescription,
  onNameChange,
  onDescriptionChange,
}) => {
  // カスタムテンプレートのみ編集可能
  const canEdit = template.templateType === 'custom'
  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
      style={{ marginBottom: '24px' }}
    >
      <table className={`${styles.container} ${styles.itemInfoTable}`}>
        <tbody>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>名前</td>
            <td className={styles.inputCell}>
              {isEditing && canEdit ? (
                <input
                  className={formStyles.input}
                  type="text"
                  value={editTemplateName}
                  onChange={e => onNameChange(e.target.value)}
                />
              ) : (
                <span>{template.name}</span>
              )}
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>説明</td>
            <td className={styles.itemInputCell}>
              {isEditing && canEdit ? (
                <textarea
                  className={formStyles.textInput}
                  value={editTemplateDescription}
                  onChange={e => onDescriptionChange(e.target.value)}
                />
              ) : (
                <span>{template.description}</span>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default PreMakingTemplateInfoForm
